import dynamic from 'next/dynamic';

const ContactFormWithOutHelperText = dynamic(() => import('./ContactFormWithOutHelperText'), { ssr: false });

export default ContactFormWithOutHelperText;
